import { sendProductImpression } from '../../../scripts/components/AdMind/impressionProduct';

function getVariantFromColorAndSize(variants, color, size) {
  const filtered = variants.filter((v) => v.option1 === color && v.inventory !== '0');
  const match = filtered.find((v) => v.option2 === size);
  return match || filtered[0] || variants[0];
}

export function SliderCartItem(props) {
  const tile = document.createElement('div');
  tile.className = 'ProductTile ProductTileAlternate ProductTile--react';
  tile.dataset.productTile = '';

  const availableVariants = props.variants.filter((v) => v.available || v.inventory > 0);
  if (availableVariants.length === 0) return null;

  const adMindProduct = {
    compare_at_price: props.product.compare_at_price,
    id: props.product.product_id,
    type: props.product.product_type,
    title: props.product.Title,
    tags: props.product.tags,
  };

  const availableColors = props.colorOptions.filter((color) => availableVariants.some((v) => v.option1 === color));
  const defaultVariant = getVariantFromColorAndSize(availableVariants, props.selectedColor || availableColors[0], null);

  let selectedColor = defaultVariant.option1;
  let availableSizes = availableVariants.filter((v) => v.option1 === selectedColor);
  let selectedSize = defaultVariant.option2;

  let selectedVariant = getVariantFromColorAndSize(props.variants, selectedColor, selectedSize);
  let currentThumbUrl = selectedVariant.image_url;
  let productUrlState = props.product_url;

  const currency_symbol = window.theme.currency_symbol || '$';
  const currency_iso = window.theme.currency_iso || 'USD';
  const currency_alt = currency_symbol === '$' && !['USD', 'HKD'].includes(currency_iso) ? currency_iso : '';
  const formatter = window.formatter || { format: (n) => n };

  const colorSelect = document.createElement('select');
  const sizeSelect = document.createElement('select');

  function populateColorOptions() {
    colorSelect.innerHTML = '';
    availableColors.forEach((color) => {
      const opt = document.createElement('option');
      opt.value = color;
      opt.textContent = color;
      opt.selected = color === selectedColor;
      opt.dataset.productId = props.id;
      colorSelect.appendChild(opt);
    });
  }

  function populateSizeOptions() {
    sizeSelect.innerHTML = '';
    availableSizes.forEach((size) => {
      const opt = document.createElement('option');
      opt.value = size.option2;
      opt.textContent = size.option2;
      opt.selected = size.option2 === selectedSize;
      opt.dataset.productId = props.id;
      sizeSelect.appendChild(opt);
    });
  }

  function updateVariant() {
    selectedVariant = getVariantFromColorAndSize(props.variants, selectedColor, selectedSize);
    currentThumbUrl = selectedVariant.image_url;

    try {
      const newURL = new URL(productUrlState, window.location.origin);
      newURL.searchParams.set('variant', selectedVariant.variant_id);
      productUrlState = newURL.href.replace('https://www.windsorstore.com', `https://${window.location.hostname}`);
    } catch (err) {
      console.warn('URL parse failed', err);
    }

    render();
  }

  colorSelect.addEventListener('change', (e) => {
    sendProductImpression(selectedVariant, adMindProduct);
    selectedColor = e.target.value;
    availableSizes = availableVariants.filter((v) => v.option1 === selectedColor);
    selectedSize = availableSizes[0]?.option2;
    populateSizeOptions();
    updateVariant();
  });

  sizeSelect.addEventListener('change', (e) => {
    sendProductImpression(selectedVariant, adMindProduct);
    selectedSize = e.target.value;
    updateVariant();
  });

  function render() {
    tile.innerHTML = '';

    if (currentThumbUrl) {
      const a = document.createElement('a');
      a.href = productUrlState;
      a.className = 'ProductTileAlternate__image';
      a.title = props.title;
      a.dataset.productId = props.id;

      const img = document.createElement('img');
      img.alt = props.id;
      img.dataset.productId = props.id;
      img.src = currentThumbUrl
        .replace('.jpg', '_300x400_crop_center.jpg')
        .replace('.webp', '_300x400_crop_center.webp');
      a.appendChild(img);

      const badgeTag = props.tags.find((tag) => tag.startsWith('Badge - '));
      if (badgeTag) {
        const badge = document.createElement('div');
        badge.className = 'ProductTile__badge';
        badge.textContent = badgeTag.replace('Badge - ', '');
        a.appendChild(badge);
      }

      tile.appendChild(a);
    }

    const info = document.createElement('div');
    info.className = 'ProductTileAlternate__info';

    const titleEl = document.createElement('p');
    titleEl.className = 'ProductTileAlternate__title truncate-2';
    const titleLink = document.createElement('a');
    titleLink.href = productUrlState;
    titleLink.textContent = props.title;
    titleEl.appendChild(titleLink);
    info.appendChild(titleEl);

    const price = document.createElement('p');
    price.dataset.productId = props.id;

    if (selectedVariant.price_compare_max > selectedVariant.price) {
      price.className = 'ProductTileAlternate__price ProductTileAlternate__price--sale';
      price.innerHTML = `
        <span class="sale">${currency_alt}${formatter.format(
          selectedVariant.price,
        )} - ${currency_alt}${formatter.format(selectedVariant.price_compare_max)}</span>
        <span class="discount">(${Math.round(
          ((selectedVariant.price_compare_max - selectedVariant.price) / selectedVariant.price_compare_max) * 100,
        )}% off)</span>
      `;
    } else {
      price.className = 'ProductTileAlternate__price';
      price.dataset.productTilePrice = '';
      price.textContent = `${currency_alt}${formatter.format(selectedVariant.price)}`;
    }

    info.appendChild(price);
    tile.appendChild(info);

    const options = document.createElement('div');
    options.className = 'ProductTileAlternate__options';

    const colorWrapper = document.createElement('div');
    colorWrapper.className = 'ProductTileAltenate__variant';
    const colorInner = document.createElement('div');
    colorInner.appendChild(colorSelect);
    colorWrapper.appendChild(colorInner);

    const sizeWrapper = document.createElement('div');
    sizeWrapper.className = 'ProductTileAltenate__variant';
    const sizeInner = document.createElement('div');
    sizeInner.appendChild(sizeSelect);
    sizeWrapper.appendChild(sizeInner);

    options.appendChild(colorWrapper);
    options.appendChild(sizeWrapper);
    tile.appendChild(options);

    const form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.enctype = 'multipart/form-data';
    form.dataset.productId = props.id;
    form.dataset.pid = selectedVariant.variant_id;
    form.dataset.isRec = props.isRec;
    form.dataset.sectionType = 'product';

    form.innerHTML = `
      <input type="hidden" name="id" value="${selectedVariant.variant_id}" />
      <input type="hidden" name="quantity" value="1" />
      <input type="hidden" name="properties[pid]" value="${props.pid}" />
      <button type="submit" name="add" class="ProductTileAlternate__button Button Button--primary" data-add-to-cart>
        <span data-add-to-cart-text>+ Add To Bag</span>
      </button>
      <script type="application/json" data-product-json data-tile-type="certona">
        ${JSON.stringify(props)}
      </script>
    `;

    tile.appendChild(form);
  }

  populateColorOptions();
  populateSizeOptions();
  render();

  return tile;
}
